var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVigenteGra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1729 1.1167L24.7965 7.37643C30.3028 9.18374 34.2757 14.3633 34.2757 20.4808C34.2757 23.3682 33.3905 26.0502 31.873 28.2633C29.3859 31.8937 25.2128 34.2753 20.4811 34.2753C18.5421 34.2753 16.6979 33.8749 15.0223 33.1477C10.1167 31.0401 6.68126 26.1609 6.68126 20.4808C6.68126 18.1676 7.25032 15.9862 8.25673 14.0735L2.52391 10.6275C0.91156 13.5518 0 16.9083 0 20.4808C0 29.0167 5.22171 36.3303 12.6512 39.4075C15.0644 40.4033 17.7096 40.9566 20.4811 40.9566C27.6471 40.9566 33.949 37.2787 37.6058 31.704C39.7292 28.4793 40.9622 24.6223 40.9622 20.4808C40.9622 11.5127 35.1978 3.89353 27.1729 1.1167Z",
    fill: "#62C776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1729 1.11706L24.7965 7.37678C23.4371 6.92364 21.9881 6.68126 20.4811 6.68126C15.1751 6.68126 10.5646 9.67939 8.25674 14.0738L2.52393 10.6278C6.00155 4.29434 12.7408 0 20.4811 0C22.8259 0 25.0758 0.395185 27.1729 1.11706Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigenteGra);
export default __webpack_public_path__ + "static/media/vigenteGra.1549546473372a52423115feb6d5f53f.svg";
export { ForwardRef as ReactComponent };